/* Conscomer — Contacto técnico */
(function () {
  'use strict';

  if (window.conscomerContactLoaded) return;
  window.conscomerContactLoaded = true;

  /* Listas permitidas: solo estos valores se aceptan desde la URL */
  var APP_LABELS = {
    tuberia: 'Tuberías industriales',
    horno: 'Hornos y calderas',
    frio: 'Refrigeración y HVAC',
    construccion: 'Construcción y ductos',
    alimento: 'Alimentos y farmacéutica',
    acustico: 'Acústico y vibración',
    fuego: 'Protección contra fuego'
  };

  var TEMP_LABELS = {
    frio: 'Menos de 20 °C',
    medio: '20 °C a 200 °C',
    alto: '200 °C a 650 °C',
    'muy-alto': 'Más de 650 °C'
  };

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function scoped(container, selector) {
    return container.querySelector(selector);
  }

  /* Preselecciona un <select> solo si está vacío y existe la opción */
  function preselect(select, value) {
    if (!select || !value) return false;
    if (select.value) return false;
    var options = select.options;
    for (var i = 0; i < options.length; i++) {
      if (options[i].value === value) {
        select.value = value;
        return true;
      }
    }
    return false;
  }

  function setInput(input, value) {
    if (!input || !value) return false;
    if (input.value) return false;
    input.value = value;
    return true;
  }

  function buildSummary(container, data) {
    var host = scoped(container, '[data-contact-prefill]');
    if (!host) return;

    while (host.firstChild) host.removeChild(host.firstChild);

    var title = el('p', 'conscomer-contact__prefill-title', 'Información seleccionada previamente');
    host.appendChild(title);

    var list = el('ul', 'conscomer-contact__prefill-list');

    if (data.aplicacionLabel) {
      var li1 = el('li');
      li1.appendChild(el('strong', null, 'Aplicación: '));
      li1.appendChild(document.createTextNode(data.aplicacionLabel));
      list.appendChild(li1);
    }
    if (data.temperaturaLabel) {
      var li2 = el('li');
      li2.appendChild(el('strong', null, 'Temperatura: '));
      li2.appendChild(document.createTextNode(data.temperaturaLabel));
      list.appendChild(li2);
    }
    if (data.producto) {
      var li3 = el('li');
      li3.appendChild(el('strong', null, 'Producto sugerido: '));
      li3.appendChild(document.createTextNode(data.producto));
      list.appendChild(li3);
    }

    host.appendChild(list);
    host.appendChild(el('p', 'conscomer-contact__prefill-note', 'Puedes editar o completar estos datos en el formulario.'));
    host.hidden = false;
  }

  function applyParams(container) {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }

    var rawApp = params.get('aplicacion');
    var rawTemp = params.get('temperatura');
    var rawProd = params.get('producto');

    /* Validación estricta contra la lista permitida */
    var aplicacion = rawApp && Object.prototype.hasOwnProperty.call(APP_LABELS, rawApp) ? rawApp : '';
    var temperatura = rawTemp && Object.prototype.hasOwnProperty.call(TEMP_LABELS, rawTemp) ? rawTemp : '';

    /* El producto es texto libre: se recorta y se usará solo como texto o value (nunca innerHTML) */
    var producto = '';
    if (rawProd) {
      producto = String(rawProd).replace(/[<>]/g, '').trim().slice(0, 120);
    }

    if (!aplicacion && !temperatura && !producto) return;

    var appliedApp = preselect(scoped(container, 'select[name="contact[aplicacion]"]'), aplicacion);
    var appliedTemp = preselect(scoped(container, 'select[name="contact[temperatura]"]'), temperatura);
    setInput(scoped(container, 'input[name="contact[producto]"]'), producto);

    buildSummary(container, {
      aplicacionLabel: aplicacion ? APP_LABELS[aplicacion] : '',
      temperaturaLabel: temperatura ? TEMP_LABELS[temperatura] : '',
      producto: producto
    });
  }

  function manageFocus(container) {
    var errors = scoped(container, '[data-contact-errors]');
    if (errors) {
      errors.focus();
      return;
    }
    var success = scoped(container, '[data-contact-success]');
    if (success) success.focus();
  }

  function setup(container) {
    if (container.dataset.conscomerContactReady === 'true') return;
    container.dataset.conscomerContactReady = 'true';

    applyParams(container);
    manageFocus(container);
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('[data-conscomer-contact]');
    Array.prototype.forEach.call(nodes, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();